import React from 'react';

import CallToAction from '../callToAction';
import { ArticleImage } from '../articleImage';

class RepresentativeOffice extends React.Component {
  constructor() {
    super();

    this.state = {
      markers: []
    };

    this.handleMarkerClick = this.handleMarkerClick.bind(this);
    this.handleMarkerClose = this.handleMarkerClose.bind(this);
  }

  componentWillReceiveProps() {
    if (this.props.representativeOffice) {
      this.setState({
        markers: [this.props.representativeOffice.location]
      });
    }
  }

  markersShowInfo(markers, targetMarker, showInfo) {
    return markers.map((marker) => {
      // turn false to close already open markers
      marker.showInfo = false;

      if (marker.key === targetMarker.key) {
        marker.showInfo = showInfo;
      }

      return marker;
    });
  }

  handleMarkerClick(targetMarker) {
    this.setState({
      markers: this.markersShowInfo(this.state.markers, targetMarker, true)
    });
  }

  handleMarkerClose(targetMarker) {
    this.setState({
      markers: this.markersShowInfo(this.state.markers, targetMarker, false)
    });
  }

  render() {
    const { t, representativeOffice } = this.props;

    if (!representativeOffice) {
      return null;
    }

    const representativeOfficeCity = representativeOffice.city
      .replace('Quirin Privatbank', '')
      .trim();

    return (
      <div className="representative-office">
        <div className="container">
          <div className="row">
            <aside className="sidebar">&nbsp;</aside>

            <article className="content margin-top-md margin-bottom-xs">
              <div className="row">
                <h1 className="no-margin">
                  {`${t('visitRepresentativeOffice')} ${representativeOfficeCity}`}
                </h1>
              </div>
            </article>

            <aside className="spacebar">&nbsp;</aside>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <aside className="sidebar">&nbsp;</aside>

            <article className="content no-margin-top margin-bottom-xs">
              <div className="row">
                <div className="col-1-of-2 main-content content-lg">
                  <p>{representativeOffice.article.teaser}</p>
                  <CallToAction
                    callToActionText={`${t(
                      'linkRepresentativeOffice'
                    )} ${representativeOfficeCity}`}
                    callToActionLink={representativeOffice.article.public_url}
                    callToActionCssClass="button-invert"
                  />
                </div>
                <div className="col-1-of-2 further-content content-sm hidden-mobile">
                  <ArticleImage
                    imageUrl={representativeOffice.article.image_teaser_content}
                    imageAlt={representativeOffice.article.image_alt_teaser}
                  />
                </div>
              </div>
            </article>

            <aside className="spacebar">&nbsp;</aside>
          </div>
        </div>
      </div>
    );
  }
}

RepresentativeOffice.propTypes = {
  t: React.PropTypes.func,
  representativeOffice: React.PropTypes.object
};

export default RepresentativeOffice;



// WEBPACK FOOTER //
// ./components/articles/RepresentativeOffice.js